/**
 * Module #34 Phase A chunk 7 — floating copilot launcher (bottom-right).
 *
 * Pure launcher: a round button with an insight-count badge. Clicking it opens
 * the single copilot panel (which holds BOTH the insight brief and the chat).
 * The parent (Copilot.tsx) hides this while the panel is open, so there's never
 * a bubble stacked on top of the panel.
 */

export interface CopilotBubbleProps {
  /** Open insight count for the badge (0 hides the badge). */
  count: number;
  /** Whether any open card is high/critical (badge turns urgent-red). */
  urgent: boolean;
  onOpen: () => void;
}

export function CopilotBubble({ count, urgent, onOpen }: CopilotBubbleProps) {
  return (
    <div style={{ position: 'fixed', bottom: '1.5rem', right: '1.5rem', zIndex: 55 }}>
      <button
        type="button"
        onClick={onOpen}
        aria-label={`Open copilot${count > 0 ? ` — ${count} item${count === 1 ? '' : 's'} need attention` : ''}`}
        style={{
          position: 'relative',
          width: '3.25rem',
          height: '3.25rem',
          borderRadius: '999px',
          border: 'none',
          background: 'var(--system-brand-accent)',
          color: 'var(--system-brand-accent-fg)',
          fontSize: '1.375rem',
          cursor: 'pointer',
          boxShadow: '0 8px 20px rgba(0,0,0,0.22)',
        }}
      >
        ✨
        {count > 0 && (
          <span
            aria-hidden="true"
            style={{
              position: 'absolute',
              top: '-0.25rem',
              right: '-0.25rem',
              minWidth: '1.25rem',
              height: '1.25rem',
              padding: '0 0.3125rem',
              borderRadius: '999px',
              background: urgent ? 'var(--danger, #dc2626)' : 'var(--surface-elev)',
              color: urgent ? '#fff' : 'var(--text)',
              border: '1px solid var(--border)',
              fontSize: '0.6875rem',
              fontWeight: 700,
              lineHeight: '1.25rem',
              textAlign: 'center',
            }}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}
      </button>
    </div>
  );
}
